module.exports = __webpack_public_path__ + "static/media/logos.12b9f48b.png";